/* tslint:disable */
/* eslint-disable */
/* @relayHash bcf332e1e1f7f35a22c365f902357d8c */

import { ConcreteRequest } from "relay-runtime";
export type ProjectRoot_QueryVariables = {
    projectId: string;
};
export type ProjectRoot_QueryResponse = {
    readonly project: {
        readonly id: string;
    } | null;
};
export type ProjectRoot_Query = {
    readonly response: ProjectRoot_QueryResponse;
    readonly variables: ProjectRoot_QueryVariables;
};



/*
query ProjectRoot_Query(
  $projectId: ID!
) {
  project(id: $projectId) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "project",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "projectId"
      }
    ],
    "concreteType": "Project",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProjectRoot_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ProjectRoot_Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ProjectRoot_Query",
    "id": null,
    "text": "query ProjectRoot_Query(\n  $projectId: ID!\n) {\n  project(id: $projectId) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'a9d2bf050aa3e07d128a8bbac7f8cb55';
export default node;
